import React from 'react';
import { IconProps } from '../types/types';

const MXTOKEN: React.FC<IconProps> = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80.3 50.3" role="img" {...props}><path d="M71.8 50.3H33.4c-6.5 0-10.6-7-7.4-12.7L44.9 4.5c3.4-6 12-6 15.4 0l18.9 33.1c3.2 5.6-.9 12.7-7.4 12.7z" style={{fill: '#008477'}}/><linearGradient id="a" gradientUnits="userSpaceOnUse" x1="32.492" y1="25.14" x2="74.557" y2="25.14"><stop offset="0" stopColor="#67f9a5"/><stop offset="1" stopColor="#029176"/></linearGradient><path d="M46.9 50.3H8.5c-6.5 0-10.6-7-7.4-12.7L20 4.5c3.4-6 12-6 15.4 0l18.9 33.1c4.5 7.2 8.5 12.7 16.8 12.7" style={{opacity: '.95', fill: 'url(#a)'}}/></svg>
);

export default MXTOKEN;
